import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    showEn:window.localStorage.getItem('showEn')=='true'?true:false,
}


export default new Vuex.Store({
    state,
    mutations:{
      updateShowEn(state,flag){
        state.showEn=flag;
        window.localStorage.setItem('showEn',flag)
      },
    },
    getters:{
      getShowEn(state){
        return state.showEn;
      }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js